import {feedSlice} from './slice';

export * from './slice';
export * from './selectors';
export default feedSlice.reducer;
